import { Check, CheckCircle, Hourglass, XCircle } from "lucide-react";
import { Timeoff } from "../types";
import { TimeoffApprovalStatusEnum } from "../enums";

export const getApprovalStatusCheck = (status?: string): JSX.Element => {
    if (status === TimeoffApprovalStatusEnum.APPROVED) {
        return <Check className="text-green-500" size={18} />;
    } else if (status === TimeoffApprovalStatusEnum.REJECTED || status === TimeoffApprovalStatusEnum.CANCELLED) {
        return <Check className="text-red-500" size={18} />;
    } else {
        return <Check className="text-yellow-500" size={18} />;
    }
};


export const getTimeOffStatusCheck = (status?: string): JSX.Element => {
    if (status === TimeoffApprovalStatusEnum.APPROVED) {
        return <CheckCircle className="text-green-600 w-8 h-8 pr-2 mt-4"  size={18} />;
    } else if (status === TimeoffApprovalStatusEnum.REJECTED || status === TimeoffApprovalStatusEnum.CANCELLED) {
        return <XCircle className="text-red-600 w-8 h-8 pr-2 mt-4"  size={18} />;
    } else {
        return <Hourglass className="text-yellow-600 w-8 h-8 pr-2 mt-4"  size={18} />;
    }
};
export const getApprovalStatusText = (status?: string): string => {
    if (status === TimeoffApprovalStatusEnum.APPROVED) {
        return "text-green-500";
    } else if (status === TimeoffApprovalStatusEnum.REJECTED || status === TimeoffApprovalStatusEnum.CANCELLED) {
        return "text-red-500";
    } else {
        return "text-yellow-500";
    }
};

export const TimeoffNavTitle: Record<string, string> = { 
    TIMEOFF_APPROVAL: "Timeoff Request",
    SHIFT_SWAPPING: "Shift Swapping Request"
}